export default __webpack_public_path__ + "media/color/utk-ca265221.svg";